module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.1ae55d88.svg";